// Production enviroment
// module.exports = "https://api.scouter.com.mx";

// Develop enviroment
module.exports = process.env.VUE_APP_API_URL;
